import { DataListItem } from '@brighte/form-components';
import { EnterpriseStructure } from '@brighte/validation';
import { getEnumKey } from '@components/StepNavigator/helper';
import { useApplicationData } from '@provider';
import { formatAddress, pascalToCamelCase } from '@utils';

export function useBeneficialOwnerSummary(): Array<{ title: string; items: DataListItem[] }> {
  const { BeneficialOwner: beneficialOwner, BusinessDetails } = useApplicationData([
    'BeneficialOwner',
    'BusinessDetails',
  ]);

  const structure = BusinessDetails?.enterprise?.structure;
  if (!structure) {
    return [];
  }

  const structureKey: string = getEnumKey(structure, EnterpriseStructure);
  const structureProp = pascalToCamelCase(structureKey);

  const beneficialOwnerValues = beneficialOwner?.enterprise?.[structureProp]?.beneficialOwners || [];

  if (!beneficialOwnerValues.length) {
    return [];
  }

  return beneficialOwnerValues.map((owner, index) => {
    return {
      title: `Beneficial owner #${index + 1}`,
      items: [
        { label: 'Name', value: `${owner?.firstName ?? ''} ${owner?.lastName ?? ''}` },
        { label: 'Home address', value: owner?.address ? formatAddress(owner.address) : '' },
        { label: 'Ownership percentage', value: owner.ownershipPercentage ? `${owner.ownershipPercentage}%` : '' },
      ],
    };
  });
}
